import { getShellLogger } from '../../common/logger'
import { environment } from '../../environments'
import { getShellApiInstance } from '../../common/shell-api-helpers'
import { authenticatedFetch } from '../auth'
import type { PbxFeatureFlagService } from './models'
import { PbxAvailableFeatureFlags, PbxFeatureFlagSetting } from './models'
import { getJiveApiBaseUrl } from '../../core/environment'

export const getMeetingsFeatureFlag = async (pbxId: string) => {
  try {
    // TODO Remove this 'if' in SCORE-1220
    // We need to bypass this auth because jiveApiBaseUrl in RC is not deployed yet.
    if (environment().environment === 'rc') {
      return await Promise.resolve({ setting: undefined, context: undefined, feature: undefined, isDefault: undefined })
    }

    const response = await authenticatedFetch<PbxFeatureFlagService>(
      `${getJiveApiBaseUrl()}/features/v1/${pbxId}/${PbxAvailableFeatureFlags.MEETINGS}`,
      {
        headers: { accept: 'application/json' },
        credentials: undefined,
      },
    )
    return await response.json()
  } catch (error) {
    getShellLogger().error('error in API call for Meetings Feature Flag', error)
  }
}

export const hasMeetingsFeatureFlag = async (): Promise<boolean> => {
  const pbxId = getShellApiInstance().context.pbx?.id
  if (pbxId) {
    const meetingsFeatureFlag = await getMeetingsFeatureFlag(pbxId)
    return meetingsFeatureFlag?.setting === PbxFeatureFlagSetting.ENABLED
  }
  return false
}

export const getStandardFeatureFlag = async (pbxId: string) => {
  try {
    // TODO Remove this 'if' in SCORE-1220
    // We need to bypass this auth because jiveApiBaseUrl in RC is not deployed yet.
    if (environment().environment === 'rc') {
      return await Promise.resolve({ setting: undefined, context: undefined, feature: undefined, isDefault: undefined })
    }

    const response = await authenticatedFetch<PbxFeatureFlagService>(
      `${getJiveApiBaseUrl()}/features/v1/${pbxId}/${PbxAvailableFeatureFlags.STANDARD}`,
      {
        headers: { accept: 'application/json' },
        credentials: undefined,
      },
    )
    return await response.json()
  } catch (error) {
    getShellLogger().error('error in API call for Standard Feature Flag', error)
  }
}

export const hasStandardFeatureFlag = async (): Promise<boolean> => {
  const pbxId = getShellApiInstance().context.pbx?.id
  if (pbxId) {
    const standardFeatureFlag = await getStandardFeatureFlag(pbxId)
    return standardFeatureFlag?.setting === PbxFeatureFlagSetting.ENABLED
  }
  return false
}

export const getResolveFeatureFlag = async (pbxId: string) => {
  try {
    // TODO Remove this 'if' in SCORE-1220
    // We need to bypass this auth because jiveApiBaseUrl in RC is not deployed yet.
    if (environment().environment === 'rc') {
      return await Promise.resolve({ setting: undefined, context: undefined, feature: undefined, isDefault: undefined })
    }

    const response = await authenticatedFetch<PbxFeatureFlagService>(
      `${getJiveApiBaseUrl()}/features/v1/${pbxId}/${PbxAvailableFeatureFlags.RESOLVE}`,
      {
        headers: { accept: 'application/json' },
        credentials: undefined,
      },
    )
    return await response.json()
  } catch (error) {
    getShellLogger().error('error in API call for Resolve Feature Flag', error)
  }
}

export const hasResolveFeatureFlag = async (): Promise<boolean> => {
  const pbxId = getShellApiInstance().context.pbx?.id
  if (pbxId) {
    const resolveFeatureFlag = await getResolveFeatureFlag(pbxId)
    return resolveFeatureFlag?.setting === PbxFeatureFlagSetting.ENABLED
  }
  return false
}
